import { Component, OnInit, Output, EventEmitter, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { AppGlobals } from '../../app.globals';
import { Location, NgIf } from '@angular/common';

import { AuthService } from 'src/app/services/auth.service';

import {
  DxButtonModule,
  DxDataGridModule,
  DxFormModule,
  DxMenuModule,
  DxToolbarModule,
  DxTabPanelModule,
  DxRadioGroupModule,
  DxDrawerModule,
  DxListModule,
  DxLoadPanelModule,
  DxToastModule,
  DxPopupModule,
  DxHtmlEditorModule,
} from 'devextreme-angular';

import { CommonModule } from '@angular/common';

import { ErrorFeedbackComponent } from '../feedback-error/error-feedback-component';

@Component({
    selector: 'app-pop-up',
    templateUrl: './pop-up.component.html',
    styleUrls: ['./pop-up.component.css',],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        CommonModule,
        DxDataGridModule,
        DxButtonModule,
        DxFormModule,
        DxMenuModule,
        DxToolbarModule,
        DxTabPanelModule,
        DxRadioGroupModule,
        DxDrawerModule,
        DxListModule,
        DxLoadPanelModule,
        DxToastModule,
        DxHtmlEditorModule,
        NgIf,
        ErrorFeedbackComponent,
        DxPopupModule
    ]
})


export class PopUpComponent implements OnInit {

  @Input() message: any = '';

  @Input() isAddFirmaAgentPopupVisible: boolean = false;

  @Input() isAddNewAgentPreCheckVisible: boolean = false;

  @Input() popUpMessage: any = '';

  @Input() popupVisible: boolean = false;

  @Input() isPopupVisible: boolean = false;

  @Input() isDeleteContactPopupVisible: boolean = false;

  @Input() isDeleteAgentPopupVisible: boolean = false;

  @Input() isDeleteContractPartnerPopupVisible: boolean = false;

  @Input() isDeleteWaitingItemPopupVisible: boolean = false;

  @Input() isErrorFeedbackPopupVisible: boolean = false;

  @Input() isAddCompanyPopupVisible: boolean = false;

  @Input() isAddContactPopupVisible: boolean = false;

  @Input() isAddNewContactPreCheckVisible: boolean = false;

  @Input() isAddNewCompanyPreCheckVisible: boolean = false;

  @Input() isAddInvestorPopupVisible: boolean = false;

  @Input() isDeleteInvestorPopupVisible: boolean = false;

  @Input() isDeleteAgentCompanyPopupVisible: boolean = false;

  @Input() isDeleteInvestorCompanyPopupVisible: boolean = false;

  @Input() showLogPopUp: boolean = false;

  @Output() popupResponse = new EventEmitter<any>;

  @Output() disablePopUpWindow = new EventEmitter<any>;

  popupContainerStyle: any = "popup-container-style";

  deleteFuctionPopupResponse: any = '';

  popupHeight: any = { height: '100%' };

  popupMaxHeight: any = { maxHeight: '80%' };

  popupWidth: any = '90%';

  logFeedbackResponse: any = '';

  dxGridVisible: boolean = true;

  logRequest: any = {
    "LogRequest": {
      "LogItemID": null,
      "LogBox": null
    },
  };

  constructor(
    private apiService: AuthService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private appGlobals: AppGlobals,
    private location: Location
  ) { }


  ngOnInit(): void {


  }

  ngAfterContentInit(): void {

  }

  closeLog(): void {
    this.showLogPopUp = false;
    this.disablePopUpWindow.emit(false);
  }

  goBack(): void {
    this.location.back()
  }

  goTo(path: string): void {
    this.router.navigate([path]);
  }

  collectDeleteResponse(value: any) {
    this.deleteFuctionPopupResponse = value;
    this.popupResponse.emit(value);
    this.isDeleteContactPopupVisible = false;
  };

  closeDeleteWaitingItemPopUp(value: any): void {
    this.isPopupVisible = value;
  }

  errorFeedbackTitle(value: any): void {
    this.popUpMessage = value;
  }

  addNewContactPreCheck(): void {
    this.popUpMessage = $localize`:@@leaveThisForm:To continue, you need to leave this form`;
  }

  addNewCompanyPreCheck(): void {
    this.popUpMessage = $localize`:@@leaveThisForm:To continue, you need to leave this form`;
  }

  resetPopup(): void {
    this.isPopupVisible = false;
    this.isDeleteContactPopupVisible = false;
    this.isErrorFeedbackPopupVisible = false;
    this.popupVisible = false
  }

  setTitle(value: any): void {
    this.popUpMessage = value;
  }

  setToastText(value: any): void {
    this.message = value;
  }

  changeTopBarColor(value: any): void {
    this.popupContainerStyle = value;
  }


  disablePopup(e: any): void {
    this.disablePopUpWindow.emit(e);
    this.showLogPopUp = e;
    this.isAddFirmaAgentPopupVisible = e;
    this.popupVisible = e;
    this.isPopupVisible = e;
    this.isDeleteContactPopupVisible = e;
    this.isDeleteAgentPopupVisible = e;
    this.isDeleteContractPartnerPopupVisible = e;
    this.isDeleteWaitingItemPopupVisible = e;
    this.isErrorFeedbackPopupVisible = e;
    this.isAddCompanyPopupVisible = e;
    this.isAddContactPopupVisible = e;
    this.isAddNewContactPreCheckVisible = e;
    this.isAddNewCompanyPreCheckVisible = e;
    this.isAddInvestorPopupVisible = e;
    this.isDeleteInvestorPopupVisible = e;
    this.isDeleteAgentCompanyPopupVisible = e;
    this.isDeleteInvestorCompanyPopupVisible = e;

  }

  refreshFocusedSelection(): void {
    this.disablePopUpWindow.emit(false);
    this.showLogPopUp = false;
    this.isAddFirmaAgentPopupVisible = false;
    this.popupVisible = false;
    this.isPopupVisible = false;
    this.isDeleteContactPopupVisible = false;
    this.isDeleteAgentPopupVisible = false;
    this.isDeleteContractPartnerPopupVisible = false;
    this.isDeleteWaitingItemPopupVisible = false;
    this.isErrorFeedbackPopupVisible = false;
    this.isAddCompanyPopupVisible = false;
    this.isAddContactPopupVisible = false;
    this.isAddNewContactPreCheckVisible = false;
    this.isAddNewCompanyPreCheckVisible = false;
    this.isAddInvestorPopupVisible = false;
    this.isDeleteInvestorPopupVisible = false;
    this.isDeleteAgentCompanyPopupVisible = false;
    this.isDeleteInvestorCompanyPopupVisible = false;
  }

  popUpHideWhenFeedbackError(e: any) {
    this.isPopupVisible = e;
    if (e === false) {
      this.refreshFocusedSelection();
    };
  }

  setPopUpVisibilityFromChild(e: any): void {
    if (e === false) {

      this.disablePopUpWindow.emit(false);

    };
  }


}